//
//
//
//
//
//

import 'babel-polyfill'

export default {
  components: {},
  data () {
    return {
      isErrorPage: false
    }
  },
  computed: {},
  beforeCreate () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  created () {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/components/onboard/index.vue